import {
  EditPricelistResponse,
} from "app/shared/model/EditPricelist";
import { normIso  } from "../currency/normalizeCurrency";
import { isFeeOffering } from "./guards";

export const buildNonFeeOfferingKey = (
  o: any
): string => {
  const type = String(o?.type ?? o?.productId?.type?.name ?? "Unknown");
  const pid = String(o?.productId?.id ?? "");
  return `${type}-${pid}`;
};

export const offeringKey = (
  o: EditPricelistResponse,
  _fallbackCurrencyIso?: string
): string => {
  if (isFeeOffering(o)) {
    const fid = (o as any)?.feeId?.id ?? (o as any)?.feeId ?? "";
    return `Fee-${fid}`;
  }

  return buildNonFeeOfferingKey(o as any);
};

export const sameProductId = (a: any, b: any): boolean => {
  if (!a || !b) return false;
  const aId = typeof a === "object" ? a.id : a;
  const bId = typeof b === "object" ? b.id : b;
  const aType =
    typeof a === "object" ? (a.type?.id ?? a.type?.name ?? a.type) : undefined;
  const bType =
    typeof b === "object" ? (b.type?.id ?? b.type?.name ?? b.type) : undefined;
  return String(aId) === String(bId) && String(aType) === String(bType);
};

